import React, { Component } from "react";
import reactCSS from "reactcss";
import { ChromePicker } from "react-color";

class ColourPreview extends Component {
	state = {
		displayColorPicker: false
	};

	handleClick = () => {
		this.setState({ displayColorPicker: !this.state.displayColorPicker });
	};

	handleClose = () => {
		this.setState({ displayColorPicker: false });
	};

	handleChange = color => {
		this.props.saveColour(this.props.stateKey, color.hex);
	};

	render() {
		const styles = reactCSS({
			default: {
				color: {
					width: "100%",
					height: "100%",
					borderRadius: "2px",
					background: `${this.props.color.hex}`
				},
				swatch: {
					width: "100%",
					height: "100%",
					padding: "0.5rem",
					background: "#fff",
					borderRadius: "1px",
					boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
					display: "inline-block",
					cursor: "pointer"
				},
				popover: {
					position: "absolute",
					zIndex: "2"
				},
				cover: {
					position: "fixed",
					top: "0px",
					right: "0px",
					bottom: "0px",
					left: "0px"
				},
				wrapper: {
					position: "absolute",
					top: "0px",
					left: "0px",
					width: "100%",
					height: "100%"
				}
			}
		});

		return (
			<div style={styles.wrapper}>
				<div style={styles.swatch} onClick={this.handleClick}>
					<div style={styles.color} />
				</div>
				{this.state.displayColorPicker ? (
					<div style={styles.popover}>
						<div style={styles.cover} onClick={this.handleClose} />
						<ChromePicker color={this.props.color} onChange={this.handleChange} disableAlpha={true} />
					</div>
				) : null}
			</div>
		);
	}
}

export default ColourPreview;
